import InputQuery from './input-query-location.vue'
export default {
	install: (Vue, opcions) => {
		Vue.component('input-query-location', InputQuery)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/components/input-query-location/input-query.js